"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import React from 'react';
import styles from './Label.module.scss.mjs';
import * as Aria from 'react-aria-components';
import clsx from 'clsx';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { useLocalizedStringFormatter } from 'react-aria';
import locales from '../../../../_virtual/_.locale.json@3b9d9e153ad753f427f375d1275fbcad.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { TunnelProvider, TunnelExit } from '@mittwald/react-tunnel';

const Label = flowComponent("Label", (props) => {
  const {
    children,
    className,
    optional,
    isDisabled,
    ref,
    unstyled = false,
    ...rest
  } = props;
  const stringFormatter = useLocalizedStringFormatter(locales);
  const rootClassName = unstyled ? className : clsx(styles.label, isDisabled && styles.disabled, className);
  const optionalMarker = /* @__PURE__ */ jsx("div", { className: styles.optional, children: stringFormatter.format("label.optional") });
  const propsContext = {
    ContextualHelpTrigger: {
      tunnelId: "contextualHelp",
      Button: {
        tunnelId: null
      }
    },
    Button: {
      tunnelId: "right",
      size: "s"
    },
    Action: {
      tunnelId: "right",
      Button: {
        tunnelId: null
      }
    }
  };
  return /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children: /* @__PURE__ */ jsx(TunnelProvider, { children: /* @__PURE__ */ jsxs(Aria.Label, { ...rest, className: rootClassName, ref, children: [
    children,
    optional && optionalMarker,
    /* @__PURE__ */ jsx(TunnelExit, { id: "contextualHelp", children: (children2) => {
      if (React.Children.count(children2) >= 1) {
        return children2;
      }
      return void 0;
    } }),
    /* @__PURE__ */ jsx(TunnelExit, { id: "right", children: (children2) => {
      if (React.Children.count(children2) >= 1) {
        return /* @__PURE__ */ jsx("div", { className: styles.right, children: children2 });
      }
      return void 0;
    } })
  ] }) }) });
});

export { Label, Label as default };
//# sourceMappingURL=Label.mjs.map
